import { BooleanSettingRow } from "./BooleanSettingRow";

const EXCLUDE_ZERO_ROYALTIES_STATEMENTS_ON_MERGED_SETTING = {
    id: "exclude_zero_royalties_statements_on_merged" as const,
    title: "Exclude detailed statements with no royalties from merged send",
    description:
        "When enabled, individual term statements with zero period royalties are not included in the merged PDF. The consolidated statement is still sent.",
};

export const ExcludeZeroRoyaltiesStatementsOnMerged = () => (
    <div className="merged-statement-sub-setting" style={{ paddingLeft: "24px", marginBottom: "8px" }}>
        <BooleanSettingRow setting={EXCLUDE_ZERO_ROYALTIES_STATEMENTS_ON_MERGED_SETTING} filterText="" />
    </div>
);
